// ----------------------------------------------------------------------------
// Snippet: Menu
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_menu.scss';
import './_menu--dropdown.scss';

// -------------------------------------
// Hooks
// -------------------------------------

function openMenu(menu, focusItem) {
    closeAllMenus(menu.$dropdown);
    // open menu
    menu.$dropdown.addClass('js--isOpen');
    menu.$dropdown.children('.menu__link').attr('aria-expanded', 'true');
    // move focus
    focusItem.focus();
}

function closeMenu(submenu) {
    // close menu
    submenu.$parentDropdown.removeClass('js--isOpen');
    submenu.$parentDropdown.children('.menu__link').attr('aria-expanded', 'false');

}

function closeAllMenus(menuDropdown) {
    menuDropdown.removeClass('js--isOpen');
    menuDropdown.siblings().removeClass('js--isOpen');
    menuDropdown.children('.menu__link').attr('aria-expanded', 'false');
    menuDropdown.siblings().children('.menu__link').attr('aria-expanded', 'false');
}

function moveFocusTo(focusItem) {
    focusItem.focus();
}

function moveTabindex(menuDropdown, menuLink) {
    menuDropdown.parents('.menu__list').find('.menu__link').attr('tabindex', '-1');
    menuLink.attr('tabindex', '0');
}

function hoverMenu() {
    if ($(window).outerWidth() >= 1024) {
        $('.menu__item--dropdown:not(.js--bound)').addClass('js--bound').on('mouseenter mouseleave', allowHoverOnMenu)
    } else {
        $('.menu__item--dropdown.js--bound').removeClass('js--bound').off('mouseenter mouseleave', allowHoverOnMenu)
    }
}

function allowHoverOnMenu(e) {

    e.preventDefault();
    if (e.type === 'mouseenter') {
        setTimeout(function(event){
            $(e.currentTarget).addClass('js--isOpen');
        }, 0);

    }
    if (e.type === 'mouseleave') {
        setTimeout(function(event){
            $(e.currentTarget).removeClass('js--isOpen');
        }, 0);

    }
}

$(function() {
    // Opens dropdowns
        $('.menu__item--dropdown .menu__link').on('click', function(e) {
            // Store elements as an object

            var $dropdown = $(this).closest('.menu__item--dropdown');

            if ($dropdown.siblings().hasClass('js--isOpen')) {
                $dropdown.siblings().removeClass('js--isOpen');
                $dropdown.addClass('js--isOpen');
            } else {
                $dropdown.toggleClass('js--isOpen');
            }

        });




        hoverMenu();
        $(window).on('resize', hoverMenu);


        $('.menu--header .menu__item .menu__link').on('keydown', function(e) {
            var menu = {
                $menuLink:          $(e.target),
                $menuItem:          $(e.target).closest('.menu__item'),
                $dropdownList:      $(e.target).closest('.dropdown__list'),
                $dropdown:          $(e.target).closest('.menu__item--dropdown'),
                $dropdownLink:      $(e.target).closest('.dropdown__link'),
            };

            if (e.type === 'keydown') {
                let key = e.key;
                if (key === "Tab") {
                    closeAllMenus(menu.$dropdown);
                } else {
                    // If not Tab
                    let menuItem,
                    menuItemLink,
                    focusLink;

                    switch(key) {
                        case 'Enter': // Enter
                            // Opens submenu and moves focus to first item in submenu
                            focusLink = menu.$dropdown.find('.dropdown__link').first();
                            openMenu(menu, focusLink);
                            break;
                        case ' ': // Space
                            // Opens submenu and moves focus to first item in submenu
                            e.preventDefault();
                            focusLink = menu.$dropdown.find('.dropdown__link').first();
                            openMenu(menu, focusLink);
                            break;
                        case 'ArrowLeft': // left
                            // Moves focus to the previous item in the menubar.
                            // If focus is on the first item, moves focus to the last item.
                            e.preventDefault();
                            menuItem = menu.$menuLink.parent().prev();
                            if (menuItem.length <= 0) {
                                menuItem = menu.$menuLink.parent().siblings().last();

                            }
                            menuItemLink = menuItem.children('.menu__link');
                            moveFocusTo(menuItemLink);
                            moveTabindex(menu.$menuItem, menuItemLink);

                            break;
                        case 'ArrowRight': // Right
                            // Moves focus to the next item in the menubar.
                            // If focus is on the last item, moves focus to the first item.
                            e.preventDefault();
                             menuItem = menu.$menuLink.parent().next();
                            if (menuItem.length <= 0) {
                                menuItem = menu.$menuLink.parent().siblings().first();

                            }
                             menuItemLink = menuItem.children('.menu__link');
                            moveFocusTo(menuItemLink);
                            moveTabindex(menu.$menuItem, menuItemLink);

                            break;
                        case 'ArrowUp': // Up
                            // Opens submenu and moves focus to last item in the submenu.
                            e.preventDefault();
                            focusLink = menu.$dropdown.find('.dropdown__link').last();
                            openMenu(menu, focusLink);
                            break;
                        case 'ArrowDown': // Down
                            // Opens submenu and moves focus to first item in the submenu.
                            e.preventDefault();
                            focusLink = menu.$dropdown.find('.dropdown__link').first();
                            openMenu(menu, focusLink);
                            break;
                        case 'Home': // Home
                            // 	Moves focus to first item in the menubar.
                            e.preventDefault();
                            menuItem = menuItem = menu.$menuLink.parent().siblings().first();
                            menuItemLink = menuItem.children('.menu__link');
                            moveFocusTo(menuItemLink);
                            moveTabindex(menu.$menuItem, menuItemLink);
                            break;
                        case 'End': // End
                            // Moves focus to last item in the menubar.
                            e.preventDefault();
                            menuItem = menuItem = menu.$menuLink.parent().siblings().last();
                            menuItemLink = menuItem.children('.menu__link');
                            moveFocusTo(menuItemLink);
                            moveTabindex(menu.$menuItem, menuItemLink);
                            break;
                        default: // Any other character?
                            // Moves focus to next item in the menubar having a name that starts with the typed character. If none of the items have a name starting with the typed character, focus does not move.
                            menu.$menuItem.siblings().each(function(index, menuItem) {
                                let menuLink = $(menuItem).children('.menu__link');
                                let firstChar = menuLink[0].innerText.charAt(0).toLowerCase();
                                if (key.toLowerCase() === firstChar) {
                                    moveFocusTo(menuLink);
                                    moveTabindex($(menuItem), menuLink);
                                    return false;
                                }
                            })
                    }
                }
            }
        });

        $('.dropdown__item .dropdown__link').on('keydown', function(e) {
            var submenu = {
                $menuLink:           $(e.target),
                $dropdown:           $(e.target).parent(),
                $dropdownSubNav:     $(e.target).parents('.dropdown__item--sub-nav'),
                $parentDropdown:     $(e.target).parents('.menu__item'),
                $parentLink:         $(e.target).parents('.menu__item').children('.menu__link')
            };

            let key = e.key;
            if (key === "Tab") {
                closeAllMenus(submenu.$parentDropdown);
            } else {
                // If not Tab
                let menuItem,
                menuItemLink,
                focusLink;

                switch(key) {
                    case 'Enter': // Enter
                        // Activates menu item, causing the link to be activated.
                        break;
                    case ' ': // Space
                        // Activates menu item, causing the link to be activated.
                        e.preventDefault();
                        submenu.$menuLink[0].click();
                        break;
                    case 'Escape':
                        // Closes submenu. Moves focus to parent menubar item.
                        closeMenu(submenu);
                        moveFocusTo(submenu.$parentLink);
                        break;
                    case 'ArrowLeft': // left
                        // Moves focus to previous item in the main menubar. Wraps to last item in main menubar.
                        e.preventDefault();
                        menuItem = submenu.$parentDropdown.prev();
                        if (menuItem.length <= 0) {
                            menuItem = submenu.$parentDropdown.siblings().last();
                        }
                        menuItemLink = menuItem.children('.menu__link');
                        closeMenu(submenu);
                        moveFocusTo(menuItemLink);
                        moveTabindex(submenu.$parentDropdown, menuItemLink);
                        break;
                    case 'ArrowRight': // Right
                        // Moves focus to next item in the main menubar. Wraps to first item in main menubar.
                        e.preventDefault();
                        menuItem = submenu.$parentDropdown.next();
                        if (menuItem.length <= 0) {
                            menuItem = submenu.$parentDropdown.siblings().first();
                        }
                        menuItemLink = menuItem.children('.menu__link');
                        closeMenu(submenu);
                        moveFocusTo(menuItemLink);
                        moveTabindex(submenu.$parentDropdown, menuItemLink);
                        break;
                    case 'ArrowUp': // Up
                        // Moves focus to previous item in the submenu.
                        // If focus is on the first item, moves focus to the last item.
                        e.preventDefault();
                        menuItem = submenu.$dropdown.prev();
                        if (menuItem.length <= 0) {
                            // If this dropdown list is a sub nav of a mega nav. Move to the first menu item of the next sub nav.
                            if (submenu.$dropdownSubNav.length) {
                                var $nextSubNav = submenu.$dropdownSubNav.prev('.dropdown__item--sub-nav').children('.dropdown__list--sub-nav');
                                menuItem = $nextSubNav.children('.dropdown__item').last();
                            } else {
                                menuItem = submenu.$dropdown.siblings().last();
                            }
                        }
                        menuItemLink = menuItem.children('.dropdown__link');
                        moveFocusTo(menuItemLink);
                        break;
                    case 'ArrowDown': // Down
                        // Moves focus to the next item in the submenu.
                        // If focus is on the last item, moves focus to the first item.
                        e.preventDefault();
                        menuItem = submenu.$dropdown.next();
                        if (menuItem.length <= 0) {
                            // If this dropdown list is a sub nav of a mega nav. Move to the first menu item of the next sub nav.
                            if (submenu.$dropdownSubNav.length) {
                                var $nextSubNav = submenu.$dropdownSubNav.next('.dropdown__item--sub-nav').children('.dropdown__list--sub-nav');
                                menuItem = $nextSubNav.children('.dropdown__item').first();
                            } else {
                                menuItem = submenu.$dropdown.siblings().first();
                            }
                        }
                        menuItemLink = menuItem.children('.dropdown__link');
                        moveFocusTo(menuItemLink);
                        break;
                    case 'Home': // Home
                        // 	Moves focus to the first item in the submenu.
                        e.preventDefault();
                        menuItem = submenu.$dropdown.siblings().first();
                        menuItemLink = menuItem.children('.dropdown__link');
                        moveFocusTo(menuItemLink);
                        break;
                    case 'End': // End
                        // Moves focus to the last item in the submenu.
                        e.preventDefault();
                        menuItem = submenu.$dropdown.siblings().last();
                        menuItemLink = menuItem.children('.dropdown__link');
                        moveFocusTo(menuItemLink);
                        break;
                    default: // Any other character?
                        e.preventDefault();
                        // Moves focus to next item in the submenu having a name that starts with the typed character. If none of the items have a name starting with the typed character, focus does not move.
                        submenu.$dropdown.siblings().each(function(index, menuItem) {
                            let menuLink = $(menuItem).children('.dropdown__link');
                            let firstChar = menuLink[0].innerText.charAt(0).toLowerCase();
                            if (key.toLowerCase() === firstChar) {
                                moveFocusTo(menuLink);
                                moveTabindex($(menuItem), menuLink);
                                return false;
                            }
                        })
                }
            }

        });


    $('.menu__item--dropdown .menu__link').on('click', function(event) {
        event.preventDefault();
    });

});
